/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import DropdownWrapper from './dropdownWrapper';
import DropdownMenu from './dropdownMenu';
import { colors } from '../colors';

interface DropdownToggleProps {
	large?: boolean;
}

const DropdownToggle = styled.button<DropdownToggleProps>`
	border: 0px;
	background: transparent;
	padding: 8px;
	border-radius: 4px;
	color: ${colors.Grey69};

	:hover,
	:focus {
		background: ${colors.GreyEC};
	}
	span {
		font-size: 16px;
	}
	${({ large }) =>
		large &&
		`width:48px;
		height:48px;
	`}
`;

interface DataParams {
	open?: boolean;
	name?: any;
	reverse?: string;
}

const Dropdown: React.FC<DataParams> = (props): any => {
	const wrapperRef = useRef<HTMLDivElement>(null);
	const { open = false, reverse = false, children } = props;
	let { name } = props;
	const [isOpen = false, setIsOpen] = useState(open);
	const toggleOpen = () => setIsOpen(!isOpen);

	if (reverse && isOpen) {
		name = reverse;
	}

	const handleClickOutside = (event: any) => {
		if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
			setIsOpen(false);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, false);
		return () => document.removeEventListener('click', handleClickOutside, false);
	}, []);

	return (
		<DropdownWrapper ref={wrapperRef}>
			<DropdownToggle onClick={toggleOpen}>{name}</DropdownToggle>
			<DropdownMenu className="app-dropdown-content-block" onClick={toggleOpen} open={isOpen}>
				{children}
			</DropdownMenu>
		</DropdownWrapper>
	);
};

export default Dropdown;
